import { render, staticRenderFns } from "./BaseWidget.vue?vue&type=template&id=20304a3f&scoped=true&"
import script from "./BaseWidget.vue?vue&type=script&lang=js&"
export * from "./BaseWidget.vue?vue&type=script&lang=js&"
import style0 from "./BaseWidget.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BaseWidget.vue?vue&type=style&index=1&id=20304a3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20304a3f",
  null
  
)

export default component.exports